var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"top5","category-name":"総合大賞","category-intro":"今年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 2020年度「いちばん読みたい・読んでもらいたいメルマガ」に輝いた総合大賞5誌を発表いたします。"}})}
var staticRenderFns = []

export { render, staticRenderFns }